<template>
  <base-form-textarea
    label="Call Reason"
    v-model="callReason.comment"
    :rules="[requiredRule]"
    class="mt-3"
    rows="2"
  />
  <base-form-datepicker
    label="Next Follow Up Date"
    type="datetime"
    :autoSubmit="false"
    v-model="callReason.followDate"
    clearable
    min-today
    class="mt-3"
  />
  <base-form-select
    label="Reminder"
    :items="reminderOptions"
    v-model="callReason.reminderType"
    class="mt-3"
  />
  <base-form-datepicker
    v-if="callReason.reminderType == 5"
    label="Reminder Time"
    type="datetime"
    :autoSubmit="false"
    v-model="callReason.reminderDate"
    clearable
    min-today
    class="mt-3"
  />
</template>

<script setup>
import { useContactCallStore } from "~/stores/contact/call";
import { requiredRule } from "~/utils/validation";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";

const { t } = useI18n();

const contactCallStore = useContactCallStore();
const { callReason } = storeToRefs(contactCallStore);

const reminderOptions = ref([
  {
    title: t("No Reminder"),
    value: 0,
  },
  {
    title: t("At Follow Up"),
    value: 1,
  },
  {
    title: t("Minutes ago", { item: 30 }),
    value: 2,
  },
  {
    title: t("Hours ago", { item: 1 }),
    value: 3,
  },
  {
    title: t("Days ago", { item: 1 }),
    value: 4,
  },
  {
    title: t("Select Custom Date"),
    value: 5,
  },
]);
</script>
